
export default class State {
  public all: string[] = [];
}


// WEBPACK FOOTER //
// ./static-content/private/javascripts/store/modules/states/state.ts